import { render, staticRenderFns } from "./EmptyQnA.vue?vue&type=template&id=63737d6a"
import script from "./EmptyQnA.vue?vue&type=script&lang=js"
export * from "./EmptyQnA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports